module.exports = __webpack_public_path__ + "static/erus-7cf491ebfb7e02dda8a358c55564dacb.webp";